import { useTranslation } from '@eti/providers';
import { Card, Heading, Notice, Text, vars } from '@etg/wings';
import { Accordion } from '@eti/components';
import { css } from '@eti/styles';

const bodyContentStyles = css`
  border-top: 1px solid ${vars.colors.divider};
  padding: 16px;
`;

const noticeTextStyles = css`
  color: ${vars.colors.text};
`;

const noticeIconStyles = css`
  align-items: center;
  display: flex;
`;

const BusinessReceipt = () => {
  const { t } = useTranslation();

  return (
    <Card padding={0}>
      <Accordion id="business-receipt-accordion" variant="full-width">
        <Card>
          <Accordion.Header data-testid="business-receipt-toggle">
            <Notice className={noticeIconStyles} variant="information">
              <Heading className={noticeTextStyles} level={2}>
                {t('Payment.BusinessReceipt.Toggle.Label')}
              </Heading>
            </Notice>
          </Accordion.Header>
        </Card>
        <Accordion.Body className={bodyContentStyles}>
          <Text>{t('Payment.BusinessReceipt.Description')}</Text>
        </Accordion.Body>
      </Accordion>
    </Card>
  );
};

export default BusinessReceipt;
